import { render } from "./HeroiconsOutlinePlus.vue?vue&type=template&id=2cee4aee"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePlus.vue"]])

export default __exports__